var React = require('react');

function IconUserSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M511.3 512c-115 0-208.1-93.1-208.1-208.1s93-208.2 208.1-208.2 208.1 93.1 208.1 208.1S626.3 512 511.3 512zm0 104c138.9 0 416.3 69.7 416.3 208.1v104.1H95v-104C95 685.8 372.4 616 511.3 616z"}));
}

IconUserSolid.displayName = "IconUserSolid";

IconUserSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconUserSolid;

IconUserSolid.default = IconUserSolid;
